// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3eM3s","modalForm":"UpgradeEpcsModal_modalForm__2LlEr","modalFooter":"UpgradeEpcsModal_modalFooter__20cBk"};